// src/components/PageSkeleton.tsx
// Premium shimmer skeleton shown while lazy screens load.
// Replaces the generic full-screen spinner for a polished feel.

import React from 'react';
import { IonPage, IonHeader, IonToolbar, IonContent } from '@ionic/react';

const Shimmer: React.FC<{
  width?: string;
  height?: string;
  borderRadius?: string;
  style?: React.CSSProperties;
}> = ({ width = '100%', height = '16px', borderRadius = '8px', style }) => (
  <div
    style={{
      width,
      height,
      borderRadius,
      background: 'linear-gradient(90deg, #F3F4F6 25%, #E9EAEC 50%, #F3F4F6 75%)',
      backgroundSize: '200% 100%',
      animation: 'nw-shimmer 1.4s ease-in-out infinite',
      flexShrink: 0,
      ...style,
    }}
  />
);

const PageSkeleton: React.FC = () => (
  <IonPage>
    <IonHeader className="ion-no-border">
      <IonToolbar style={{ '--background': '#FAF8F0' } as React.CSSProperties}>
        <div style={{ padding: '8px 20px' }}>
          <Shimmer width="150px" height="22px" borderRadius="8px" />
        </div>
      </IonToolbar>
    </IonHeader>

    <IonContent style={{ '--background': '#FAF8F0' } as React.CSSProperties}>
      <div style={{ padding: '20px' }}>

        {/* Hero card */}
        <Shimmer height="140px" borderRadius="20px" style={{ marginBottom: '20px' }} />

        {/* 2-column mini cards */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
          <Shimmer height="88px" borderRadius="16px" />
          <Shimmer height="88px" borderRadius="16px" />
        </div>

        {/* Section header */}
        <Shimmer width="120px" height="14px" borderRadius="6px" style={{ marginBottom: '16px' }} />

        {/* List rows */}
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '16px' }}
          >
            <Shimmer width="48px" height="48px" borderRadius="14px" />
            <div style={{ flex: 1 }}>
              <Shimmer width="55%" height="14px" borderRadius="6px" style={{ marginBottom: '8px' }} />
              <Shimmer width="35%" height="12px" borderRadius="6px" />
            </div>
            <Shimmer width="28px" height="28px" borderRadius="8px" />
          </div>
        ))}

      </div>

      <style>{`
        @keyframes nw-shimmer {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </IonContent>
  </IonPage>
);

export default PageSkeleton;
